<template>
  <div 
    style="text-align:center;height:900px;"
  >
    <iframe 
      class="iframe-totem" 
      v-if="url" 
      :src="url" 
      style="border:0;width: 100%;height:980px;"
      frameborder="0"
      width="100%"
      seamless="seamless"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'
export default {
  props: {
    enterprise: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    url: null,
  }),
  computed: {
    ...mapState('app',['totemActiveMenu', 'totemIframeURL']),
  },
  watch: {
    locale () {
      this.prepareURL()
    },
    totemActiveMenu () {
      this.prepareURL()
    },
  },
  mounted () {
    this.prepareURL()
  },
  methods: {
    prepareURL () {
      const urls = this.$store.state.app.totemIframeURL
      this.url = utils.getTranslation(urls, this.locale)
    },
  },
}
</script>
<style scoped>
.iframe-totem {
  overflow-x:hidden;
  overflow-y:hidden;
  overflow:hidden;
}
</style>

